import styled from 'styled-components';

export const UiAnnouncementCard = styled.div`
	display: block;
`;